export default {
	FORM: 'FORM',
	FIELD: 'FIELD',
	ACTION: 'ACTION',
	GRID: 'GRID'
}
